import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/refinancia/JC-colombia-horizontal.png'
import _imports_1 from '@/assets/img/BotonPSE.png'


const _withScopeId = n => (_pushScopeId("data-v-3a7ad282"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inset-0 z-50 grid grid-cols-1 lg:grid-cols-3 grid-rows-2f overflow-x-hidden overflow-y-auto rounded-md h-screen" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center lg:flex-none lg:justify-start lg:row-start-1 lg:col-span-3 p-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-10",
    src: _imports_0,
    alt: "Logo refinancia"
  })
], -1))
const _hoisted_3 = { class: "row-start-2 lg:col-span-1 lg:col-start-2 m-3 lg:m-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-primary font-bold lg:text-left mt-4 lg:mt-0" }, " Información general de pago ", -1))
const _hoisted_5 = {
  key: 0,
  class: "relative bg-white rounded-xl shadow-lg px-4 py-8 my-3"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "pse",
  class: "btn-pse"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-4" }, null, -1))
const _hoisted_8 = { class: "text-center mt-2 mb-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold text-primary" }, [
  /*#__PURE__*/_createTextVNode("Valor total a pagar"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_10 = { class: "text-sm text-left text-gris80" }
const _hoisted_11 = { class: "text-center py-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold text-primary" }, [
  /*#__PURE__*/_createTextVNode("Fecha límite de pago"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_13 = { class: "text-sm text-left text-gris80" }
const _hoisted_14 = { class: "text-center py-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold text-primary" }, [
  /*#__PURE__*/_createTextVNode("Comercio"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_16 = { class: "text-sm text-left text-gris80" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-6" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "pse",
  class: "btn-pse"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gris80 mt-3 text-sm py-2" }, " Para conocer los canales de pago físico. ", -1))
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  href: "",
  ref: "iPhoneLink",
  rel: "noreferrer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalPaymentChannels = _resolveComponent("ModalPaymentChannels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_ctx.validData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onlinePayment && _ctx.onlinePayment(...args)), ["prevent"])),
              class: "px-4 py-2 text-sm mt-3 text-white rounded-lg bg-success w-48 md:w-44 md:mt-0 md:text-sm order-first md:order-none btn-pse-container h-10 my-3"
            }, [
              _hoisted_6,
              _createTextVNode(" Pague aquí ")
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$filters.currency(_ctx.dataDecrypted.amount)), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.dataDecrypted.payday_limit), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.dataDecrypted.commerce), 1)
            ]),
            _hoisted_17,
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onlinePayment && _ctx.onlinePayment(...args)), ["prevent"])),
              class: "px-4 py-2 text-sm mt-3 text-white rounded-lg bg-success w-48 md:w-44 md:mt-0 md:text-sm order-first md:order-none btn-pse-container h-10"
            }, [
              _hoisted_18,
              _createTextVNode(" Pague aquí ")
            ]),
            _hoisted_19,
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["button_payment", { 'cursor-not-allowed': _ctx.disabledPaymentChannels }]),
              disabled: _ctx.disabledPaymentChannels,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.physicalPayment && _ctx.physicalPayment(...args)))
            }, " Pago en efectivo ", 10, _hoisted_20),
            _createVNode(_component_ModalPaymentChannels, {
              "is-visible": _ctx.showModalPaymentChannels,
              "custom-margin": false,
              paymentChannels: _ctx.getReferenceAndAgreement,
              onClose: _ctx.closeModalPaymentChannels
            }, null, 8, ["is-visible", "paymentChannels", "onClose"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("a", _hoisted_21, null, 512)
  ]))
}